var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBilling = function SvgBilling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M62 22H18a6 6 0 0 0-6 6v24a6 6 0 0 0 6 6h44a6 6 0 0 0 6-6V28a6 6 0 0 0-6-6m-44-2a8 8 0 0 0-8 8v24a8 8 0 0 0 8 8h44a8 8 0 0 0 8-8V28a8 8 0 0 0-8-8z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M68.527 28.679H10.938v-2h57.588zM68.527 34.81H10.938v-2h57.588zM15.537 44.977a1 1 0 0 1 1-1h20.116a1 1 0 1 1 0 2H16.537a1 1 0 0 1-1-1M15.537 48.977a1 1 0 0 1 1-1h20.116a1 1 0 1 1 0 2H16.537a1 1 0 0 1-1-1M15.537 52.977a1 1 0 0 1 1-1h20.116a1 1 0 1 1 0 2H16.537a1 1 0 0 1-1-1M60.353 44.255h-8v8h8zm-8-2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })));
};
export default SvgBilling;